import { supabase } from './supabase'

export async function upsertUser(uid: string) {
  const payload = { id: uid, vip: false, last_seen: new Date().toISOString() }
  const { error } = await supabase
    .from('appicon')
    .upsert(payload, { onConflict: 'id' })
  if (error) throw new Error(error.message)
}

export async function touchUser(uid: string) {
  const { error } = await supabase
    .from('appicon')
    .update({ last_seen: new Date().toISOString() })
    .eq('id', uid)
  if (error) throw new Error(error.message)
}